import { createContext, PropsWithChildren, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../../contracts";
import { useCourse } from "../course";
import { ExtraClass } from "../../contracts/extraClasses/dto";
import { useVideoPlayer } from "../videoPlayer";

type ContextExtraClassData = {
    extraClasses: ExtraClass[];
    getExtraClasses: () => Promise<ExtraClass[]>;
};

const DEFAULT: ContextExtraClassData = {
    extraClasses: [],
    getExtraClasses: () => ({} as any),
};

const ExtraClassContext = createContext(DEFAULT);

export const ExtraClassProvider = ({ children }: PropsWithChildren<any>) => {
    const { type } = useCourse();

    const [extraClasses, setExtraClasses] = useState<ExtraClass[]>([]);
    const { setConfig } = useVideoPlayer();
    
    useEffect(() => {
        setConfig({
            labelNext: 'Próxima Aula',
            labelPrevius: 'Aula Anterior'
        });
    }, [setConfig])

    const getExtraClasses = useCallback(async () => {
        const response = await api.extraClass.getExtraClasses(type);
        setExtraClasses(response);
        return response;
    }, [type]);

    return <ExtraClassContext.Provider
        value={{
            extraClasses: extraClasses,
            getExtraClasses: getExtraClasses,
        }}>
        {children}
    </ExtraClassContext.Provider>
}

export function useExtraClasses(): ContextExtraClassData {
    const context = useContext(ExtraClassContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}